<div
    class="density-user-picker"
    [class.has-value]="!!displayValue">
    <div class="density-user-picker__input-wrapper">
        <density-input-text
            [inputId]="inputId"
            [label]="label"
            [placeholder]="placeholder"
            [readOnly]="true"
            [disabled]="isDisabled"
            [invalid]="invalid"
            [styleClass]="styleClass"
            [ngModel]="displayValue"
            (ngModelChange)="onInputChange($event)">
        </density-input-text>
        @if (displayValue && !isDisabled) {
        <ds-button
            variant="ghost"
            size="sm"
            icon="close"
            class="density-user-picker__clear-button"
            (keydown.enter)="onClear()"
            (click)="onClear()">
        </ds-button>
        }
    </div>
    <ds-button
        ds-loading
        variant="outline"
        size="md"
        class="density-user-picker__button"
        icon="search"
        (keydown.enter)="onSearchClick()"
        (click)="onSearchClick()"
        [isLoading]="isLoading"
        [disabled]="isDisabled || (isExternalLoading && !isLoading)"></ds-button>
    @if (currentUser) {
    <ds-button
        ds-loading
        variant="outline"
        size="md"
        class="density-user-picker__button"
        icon="user"
        (keydown.enter)="onAssignCurrentUserClick()"
        (click)="onAssignCurrentUserClick()"
        [isLoading]="isLoading"
        [disabled]="isDisabled || (isExternalLoading && !isLoading)"></ds-button>
    }
</div>
